/* eslint-disable no-unused-vars */

/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react';
import { Refresh, DashboardOutlined } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { StyledButton } from 'app/components';
import { Colors, DarkmodeColors } from 'app/constants/color';
import { routes } from 'app/routes';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            width: '100vw',
            textAlign: 'center',
            backgroundColor: localStorage.getItem('theme') ? DarkmodeColors.appBar : '#f1f1f1',
          }}
        >
          <div>
            <img
              src='./assets/images/wentwrong.svg'
              alt=''
              style={{ width: '100%', height: '100%' }}
            />
            <StyledButton
              onClick={() => window.location.reload(true)}
              name='Save'
              startIcon={<Refresh />}
              sx={{ marginTop: '0px', marginRight: '10px' }}
            >
              Refresh Page
            </StyledButton>

            <StyledButton
              onClick={() => window.location.replace(routes.HOME)}
              name='Save'
              startIcon={<DashboardOutlined />}
              sx={{ marginTop: '0px' }}
            >
              Back to Dashboard
            </StyledButton>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
